import * as React from 'react';
import { themr } from 'react-css-themr';
import IconButton from 'react-toolbox/lib/button/IconButton';
import calendarFactory from 'react-toolbox/lib/date_picker/Calendar';
import datePickerDialogFactory from 'react-toolbox/lib/date_picker/DatePickerDialog';
import dateTheme from 'react-toolbox/lib/date_picker/theme.scss';
import Dialog from 'react-toolbox/lib/dialog';
import { DATE_PICKER, TIME_PICKER } from 'react-toolbox/lib/identifiers';
import Input from 'react-toolbox/lib/input';
import timePickerDialogFactory from 'react-toolbox/lib/time_picker/TimePickerDialog';
import timeTheme from 'react-toolbox/lib/time_picker/theme.scss';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
var Calendar = calendarFactory(IconButton);
var ThemedDatePickerDialog = themr(DATE_PICKER, dateTheme)(datePickerDialogFactory(Dialog, Calendar));
var ThemedTimePickerDialog = themr(TIME_PICKER, timeTheme, { withRef: true })(timePickerDialogFactory(Dialog));
var enhance = compose(withState('picker', 'setPicker', null), withState('tmpValue', 'setTmpValue', null));
function isoFormat(date) {
    return date.toISOString();
}
export var StatelessDateTimePicker = function StatelessDateTimePicker(_ref) {
    var picker = _ref.picker,
        setPicker = _ref.setPicker,
        tmpValue = _ref.tmpValue,
        setTmpValue = _ref.setTmpValue,
        DatePicker = _ref.DatePicker,
        TimePicker = _ref.TimePicker,
        onChange = _ref.onChange,
        value = _ref.value,
        locale = _ref.locale,
        sundayFirstDayOfWeek = _ref.sundayFirstDayOfWeek,
        cancelLabel = _ref.cancelLabel,
        disabledDates = _ref.disabledDates,
        enabledDates = _ref.enabledDates,
        maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        timeFormat = _ref.timeFormat,
        label = _ref.label,
        onBlur = _ref.onBlur,
        inputClassName = _ref.inputClassName,
        disabled = _ref.disabled,
        _ref$inputFormat = _ref.inputFormat,
        inputFormat = _ref$inputFormat === undefined ? isoFormat : _ref$inputFormat,
        error = _ref.error;

    var dateValue = value && typeof value === 'string' ? new Date(value) : value || new Date();
    dateValue.setSeconds(0);
    var timePicker = void 0;
    return React.createElement("div", null, React.createElement(DatePicker, { active: picker === 'date', value: dateValue, onDismiss: function onDismiss() {
            return setPicker(null);
        }, onEscKeyDown: function onEscKeyDown() {
            return setPicker(null);
        }, onOverlayClick: function onOverlayClick() {
            return setPicker(null);
        }, onSelect: function onSelect(value) {
            setPicker('time');
            setTmpValue(value);
            timePicker.handleClockChange(value);
        }, locale: locale, sundayFirstDayOfWeek: sundayFirstDayOfWeek, cancelLabel: cancelLabel, disabledDates: disabledDates, enabledDates: enabledDates, maxDate: maxDate, minDate: minDate }), React.createElement(TimePicker, { ref: function ref(t) {
            return timePicker = t && t.refs.wrappedInstance;
        }, active: picker === 'time', cancelLabel: cancelLabel, onDismiss: function onDismiss() {
            return setPicker(null);
        }, onEscKeyDown: function onEscKeyDown() {
            return setPicker(null);
        }, onOverlayClick: function onOverlayClick() {
            return setPicker(null);
        }, onSelect: function onSelect(value) {
            onChange(value.toISOString());
            setPicker(null);
            setTmpValue(null);
        }, value: tmpValue || dateValue, format: timeFormat }), React.createElement(Input, { className: inputClassName, label: label, error: error, disabled: disabled, onFocus: function onFocus() {
            return setPicker('date');
        }, onBlur: onBlur, value: value && inputFormat(dateValue) }));
};
export var DateTimePicker = enhance(function (props) {
    return React.createElement(StatelessDateTimePicker, Object.assign({}, props, { DatePicker: ThemedDatePickerDialog, TimePicker: ThemedTimePickerDialog }));
});
//# sourceMappingURL=datetime-picker.js.map
